/* eslint max-len: ["error", 200] */

import 'isomorphic-fetch';
import './components/translations';
import './components/elog_init';
import User from './components/user';
import AppInitializer from './components/app_initializer';
import './components/discovery';

import ReverifyCreditCard from './components/bundled_checkout/reverify_credit_card';
import PollConfirmation from './components/bundled_checkout/poll_confirmation';
import PasswordOrGuestCheckoutSelection from './components/bundled_checkout/password_or_guest_checkout_selection';
import CheckoutEmailInput from './components/bundled_checkout/checkout_email_input';
import CheckoutDeleteCreditCardButton from '@reverbdotcom/discovery-ui/dist/credit_cards/checkout_delete_credit_card_button';
import PasswordInput from './components/shared/password_input';
import AsyncLoader from './components/async_loader';
import CategorySelect from './components/category_select';

import ImportsProgressBar from '@reverbdotcom/discovery-ui/dist/dashboard/imports/progress_bar';
import EmailOfferForm from '@reverbdotcom/discovery-ui/dist/dashboard/selling/email_offers/email_offer_form';
import OrderNotes from '@reverbdotcom/discovery-ui/dist/dashboard/selling/order_notes/order_notes';
import AcceptedPaymentMethodsForm from '@reverbdotcom/discovery-ui/dist/dashboard/selling/shop_policies/accepted_payment_methods_form';
import Reports from '@reverbdotcom/discovery-ui/dist/dashboard/selling/reports/reports';

import EmailSignup from './components/email_signup/email_signup';
import Forms from './components/forms';
import GiftCardOptions from './components/gift_cards/gift_card_options';

import CanonicalProductMatcher from './components/listing_form/canonical_product_matcher';
import LocalizedContent from './components/listing_form/localized_content';
import ListingFormVideos from './components/listing_form/videos';
import ConditionExplanation from './components/listing_form/condition_explanation';
import TaxExemptCheckbox from './components/listing_form/tax_exempt_checkbox';
import MakeModel from './components/listing_form/make_model';
import ListingAttributes from './components/listing_form/listing_attributes';
import ListingAttributesContainer from './components/listing_form/listing_attributes_container';
import TraitSelect from './components/listing_form/trait_select';

import Loading from './components/shared/loading';
import ManualShippingInfoForm from './components/manual_shipping_info_form';
import TrackOrderForm from './components/track_order_form';
import OfferInput from './components/offers/offer_input';
import OfferModal from './components/offers/offer_modal';
import PageSearchBar from './components/shared/page_search_bar';
import PreviousOrders from './components/previous_orders';
import KeepShopping from './components/keep_shopping/keep_shopping';

import PriceGuideChart from './components/price_guide/transaction_history/chart';
import PriceGuideTable from './components/price_guide/transaction_history/table';
import ProductReviews from '@reverbdotcom/discovery-ui/dist/product_reviews/product_reviews';
import ShippingProgressBar from './components/shared/shipping_progress_bar';
import ReferAFriendSocialButtons from './components/refer_a_friend_social_buttons';

import AmountFields from './components/bank_transfer_requests/amount_fields';

import ShareInput from './components/shared/share_input';
import Fotorama from './components/shared/fotorama';
import ShippingLabelAddressBox from './components/shipping_labels/address_box';
import ShopPaymentMethodSelector from '@reverbdotcom/discovery-ui/dist/shop/payment_method_selector';
import ShopPaypalProfile from '@reverbdotcom/discovery-ui/dist/shop/paypal_profile';
import ShopCurrencySelect from '@reverbdotcom/discovery-ui/dist/shop/currency_select';
import StreetAddressInput from './components/bundled_checkout/street_address_input';
import DigitalListingDownloadButton from '@reverbdotcom/discovery-ui/dist/digital_listings/standalone_download_button';
import ListingShippingRateRecommendation from '@reverbdotcom/discovery-ui/dist/components/sell/listing_shipping_rate_recommendation';
import RelatedContent from '@reverbdotcom/discovery-ui/dist/product_show_page/related_content';
import SimilarListings from '@reverbdotcom/discovery-ui/dist/product_show_page/similar_listings';
import CartUpsells from './components/cart/cart_upsells';
import OtherBuyersWithListingInCart from './components/listings/other_buyers_with_listing_in_cart';

import StandaloneAjaxAddToCartButton from './components/listings/cart/standalone_ajax_add_to_cart_button';
import WatchButton from './components/listings/watch_button';

import Embeds from './components/conversations/embeds';
import MobileAppAds from './components/bundled_checkout/mobile_app_ads';

import Events from './components/event_tracking';
import NavDropdownStore from './components/header/dropdown_store';

import RelatedArticles from './components/articles/related_articles';

import TooltipWrapper from './components/tooltip_wrapper';
import ReadMessagesToggle from './components/read_messages_toggle';

import CheckoutHeader from '@reverbdotcom/discovery-ui/dist/components/checkout_header';
import AffirmLearnMoreModal from '@reverbdotcom/commons/dist/components/affirm_learn_more_modal';

import Renderer from './components/react_renderer';

// legacy components which can't be deferred
import { UI } from './components/legacy/ui';
import './components/legacy/init/hoverIntent';
import './components/legacy/readmore';
import './components/legacy/init/powertip';

// Some pages initialize this in script tags (e.g. /artist)
import './components/legacy/init/owl-carousel';
import YoutubeAPI from './components/legacy/youtube_api'; // /videos

import { ZendeskButton } from './components/zendesk_button';

AppInitializer.init();

// Async load vintage JS
require.ensure(
  [],
  (require) => {
    require('./components/legacy');
  },
  'legacy',
);

window.User = User;

window.Reverb = { ...window.Reverb,
  ZendeskButton,
  ListingShippingRateRecommendation,
  AsyncLoader,
  CartUpsells,
  CategorySelect,
  DigitalListingDownloadButton,
  EmailSignup,
  Events,
  Forms,
  Fotorama,
  Loading,
  ManualShippingInfoForm,
  TrackOrderForm,
  MobileAppAds,
  NavDropdownStore,
  OfferInput,
  OfferModal,
  OtherBuyersWithListingInCart,
  PageSearchBar,
  PreviousOrders,
  PriceGuideChart,
  PriceGuideTable,
  ProductReviews,
  ShippingProgressBar,
  ReadMessagesToggle,
  Renderer,
  ReferAFriendSocialButtons,
  ShareInput,
  ShippingLabelAddressBox,
  ShopCurrencySelect,
  ShopPaymentMethodSelector,
  ShopPaypalProfile,
  StreetAddressInput,
  TooltipWrapper,
  UI,
  YoutubeAPI,
  KeepShopping,
  CheckoutHeader,
  AffirmLearnMoreModal,
};

window.Reverb.ReactUJS = { init: Renderer.render }; // TODO remove after frontend updated to use Renderer
window.Reverb.Articles = { RelatedArticles };

window.Reverb.BankTransferRequests = {
  AmountFields,
};

window.Reverb.BundledCheckout = {
  ...window.Reverb.BundledCheckout,
  ReverifyCreditCard,
  PollConfirmation,
  PasswordOrGuestCheckoutSelection,
  CheckoutEmailInput,
  PasswordInput,
  CheckoutDeleteCreditCardButton,
};

window.Reverb.Conversations = window.Reverb.Conversations || {};
window.Reverb.Conversations.Embeds = Embeds;

window.Reverb.Dashboard = {
  AcceptedPaymentMethodsForm,
  Imports: {
    ProgressBar: ImportsProgressBar,
  },
  Reports,
  Selling: {
    EmailOffers: { EmailOfferForm },
    OrderNotes,
  },
};

window.Reverb.GiftCard = {
  GiftCardOptions,
};

window.Reverb.ListingForm = {
  CanonicalProductMatcher,
  LocalizedContent,
  Videos: ListingFormVideos,
  ConditionExplanation,
  TaxExemptCheckbox,
  MakeModel,
  ListingAttributes,
  ListingAttributesContainer,
  TraitSelect,
};

window.Reverb.Listings = {
  StandaloneAjaxAddToCartButton,
  WatchButton,
  OtherBuyersWithListingInCart,
};

window.Reverb.ProductShowPage = {
  RelatedContent,
  SimilarListings,
};



// WEBPACK FOOTER //
// ./javascripts/components.js